import { render, staticRenderFns } from "./IseIadeAlacakFormWizard.vue?vue&type=template&id=48fb1b1d"
import script from "./IseIadeAlacakFormWizard.vue?vue&type=script&lang=ts"
export * from "./IseIadeAlacakFormWizard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports